import { legacyWindow } from '../strangler'

// Typed doorway to the GLOBAL break_eternity Decimal (loaded as a plain
// script; the bundle cannot import it until cutover vendors it — at which
// point only this file changes).
//
// The declaration covers exactly the surface the game uses (verified scan,
// 2026-08-31: 885 constructions, 4 statics, 19 instance methods + toFixed +
// instance max, 2 properties), warts intact and deliberate:
// - DecimalSource includes exponent STRINGS: .mul("e550"), .gte("eeee10").
// - `mag`/`layer` are the internal representation; format() (script.js:64)
//   WRITES mag on a copy, so mag is not readonly.
// - `isNan` is break_eternity's own lowercase-a spelling, not a game typo.
//   A future bignum swap behind this doorway is where it gets an alias.

export type DecimalSource = number | string | Decimal

export interface Decimal {
  mag: number
  readonly layer: number

  add(x: DecimalSource): Decimal
  sub(x: DecimalSource): Decimal
  mul(x: DecimalSource): Decimal
  /** break_eternity's long-form alias; the game uses it exactly once (script.js:1525). */
  multiply(x: DecimalSource): Decimal
  div(x: DecimalSource): Decimal
  pow(x: DecimalSource): Decimal
  max(x: DecimalSource): Decimal
  floor(): Decimal
  ceil(): Decimal
  round(): Decimal
  sqrt(): Decimal
  log10(): Decimal
  log2(): Decimal
  slog(): Decimal
  gt(x: DecimalSource): boolean
  gte(x: DecimalSource): boolean
  lt(x: DecimalSource): boolean
  eq(x: DecimalSource): boolean
  isNan(): boolean
  toNumber(): number
  toString(): string
  toFixed(digits: number): string
}

export interface DecimalConstructor {
  new (value: DecimalSource): Decimal
  max(a: DecimalSource, b: DecimalSource): Decimal
  min(a: DecimalSource, b: DecimalSource): Decimal
  affordGeometricSeries(
    resource: DecimalSource, priceStart: DecimalSource,
    priceRatio: DecimalSource, currentOwned: DecimalSource
  ): Decimal
  sumGeometricSeries(
    numItems: DecimalSource, priceStart: DecimalSource,
    priceRatio: DecimalSource, currentOwned: DecimalSource
  ): Decimal
}

export const Dec = legacyWindow.Decimal as DecimalConstructor
